/* eslint-disable */

import Vue from 'vue';
import VueObserveVisibility from 'vue-observe-visibility';
import app from '../app/components/app.vue';

console.log('Vue app script loaded');
console.log('Map element exists:', !!document.getElementById('c-map'));
console.log('Initial data:', { mapFeedData, mapTaxonomyData });

var map = new Vue({
  el: '#c-map',
  render: (h) => h(app),
});

console.log('Vue app mounted');



// WEBPACK FOOTER //
// /Users/justin/Sites/southleft/504healthnet/wp-content/themes/healthy-hospitality/resources/assets/scripts/app.js